import React, { Component } from "react";
import { Typography, Button } from "@material-ui/core";
import { GetWalletDetails } from "../../../../services";
import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";
import swal from "sweetalert";
export default class View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getList: [],
      isLoaded: false,
    };
  }

  handleBack() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ isLoaded: true });
    this.getWalletPackages();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.getWalletPackages();
    }
  }

  async getWalletPackages() {
    let list = await GetWalletDetails.getAllWalletPackageList();
    if (list) {
      this.setState({ getList: list.data, isLoaded: false });
    }
  }

  async handlDeleteById(id) {
    swal({
      title: "Are you sure?",
      text: "You want to delete Wallet Package from the List",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        let value = await GetWalletDetails.getWalletPackageDelete(id);
        if (value) {
          NotificationManager.success(value.msg, "Status");

          // ✅ Instead of reload, update state
          this.setState((prevState) => ({
            getList: prevState.getList.filter((wallet) => wallet.id !== id),
          }));
        }
      }
    });
  }

  handlEditRow(row) {
    this.props.history.push({
      pathname: `/admin/wallet/edit/${row.id}`,
      state: row,
    });
  }
  handleAddNewPackage() {
    this.props.history.push({ pathname: `/admin/wallet/create` });
  }
  render() {
    const { getList, isLoaded } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9 col-lg-6">
            <h2 className="mt-30 page-title">Wallet Management</h2>
          </div>
          <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
            <Button variant="contained" onClick={(e) => this.handleBack()}>
              <i class="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>
        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">Dashboard</li>
          <li className="breadcrumb-item active">Wallet</li>
        </ol>
        <div className="row justify-content-between">
          <div className="col-lg-3 col-md-4">
            <div className="bulk-section mt-30">
              <div className="input-group">
                <select id="action" name="action" className="form-control">
                  <option selected>Bulk Actions</option>
                  <option value={1}>Active</option>
                  <option value={2}>Inactive</option>
                  <option value={3}>Delete</option>
                </select>
                <div className="input-group-append">
                  <button className="status-btn hover-btn" type="submit">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
            <Button
              variant="contained"
              className="status-btn hover-btn"
              onClick={(e) => this.handleAddNewPackage()}
            >
              Add New Package
            </Button>
          </div>
          <div className="col-lg-12 col-md-12">
            {isLoaded ? <Loader /> : ""}
            <div className="card card-static-2 mt-30 mb-30">
              <div className="card-title-2">
                <h4>All Wallet Packages</h4>
              </div>
              <div className="card-body-table">
                <div className="table-responsive">
                  <table className="table ucp-table table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>
                          <input type="checkbox" className="check-all" />
                        </th>
                        <th style={{ width: 60 }}>Id</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {getList.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="checkbox"
                              className="check-item"
                              name="ids[]"
                              defaultValue={row.id}
                            />
                          </td>
                          <td>{++index}</td>
                          <td>{row.amount}</td>
                          <td>
                            <td>
                              {row.status === "Active" ? (
                                <span className="text-success">Active</span>
                              ) : (
                                <span className="text-danger">Inactive</span>
                              )}
                            </td>
                          </td>
                          <td className="action-btns">
                            <a onClick={() => this.handlEditRow(row)}>
                              <i className="fas fas fa-edit" />
                            </a>
                            {/* <Typography
                              className="delete-btn"
                              onClick={() => this.handlDeleteById(row.id)}
                            >
                              <i className="fas fa-trash-alt" />
                            </Typography> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/wallet/view/index.js